var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5762 24.4192V3.61279H2.54392V30.7096H24.802L31.5762 24.4192Z",
    fill: "#7CAF92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5762 21.516V0.709595H2.54392V27.8064H24.802L31.5762 21.516Z",
    fill: "#7CAF92",
    stroke: "white",
    strokeWidth: 1.41921
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 7.70959H26.3337V10.0429H24.0003V7.70959ZM21.667 12.3763V10.0429H24.0003V12.3763H21.667ZM19.3337 14.7096V12.3763H21.667V14.7096H19.3337ZM17.0003 17.0429H19.3337V14.7096H17.0003V17.0429ZM14.667 19.3763H17.0003V17.0429H14.667V19.3763ZM12.3337 19.3763V21.7096H14.667V19.3763H12.3337ZM10.0003 17.0429H12.3337V19.3763H10.0003V17.0429ZM10.0003 17.0429H7.66699V14.7096H10.0003V17.0429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b5967a79b474f92cbbaf65c49f9e4d45.svg";
export { ForwardRef as ReactComponent };